import { getGlobalSettingsAccount } from 'owa-account-source-list-store';

export default function getFeatureFlagsKeyForSourceId(sourceId: string | undefined): string {
    return isGlobalFeaturesAccount(sourceId) ? '' : sourceId!;
}

/** Use the global account features if the global account sourceId is provide or, by default
 *  if no name is provided
 * @param sourceId the source id to test
 * @returns true if the sourceId is associated with features for the global account.
 */
function isGlobalFeaturesAccount(sourceId: string | undefined): boolean {
    if (!sourceId) {
        return true;
    } else {
        const globalAccount = getGlobalSettingsAccount();
        if (!globalAccount) {
            return true;
        } else {
            return globalAccount.sourceId === sourceId;
        }
    }
}
